import { Icon } from '@iconify/react'
import { Edit } from '@mui/icons-material'
import { Box, Button, Card, CardContent, Divider, Typography } from '@mui/material'
import { t } from 'i18next'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../store'

type CommentSectionProps = {
    comment?: string,
    onEdit?: () => void
}
function CommentSection({ comment, onEdit }: CommentSectionProps) {
    const restrictedMode = useSelector<RootState>(state => state.user.restrictedMode) as boolean

    return (
        <Card sx={{ padding: 1, minHeight: '100px', flexGrow: 1, minWidth: { xs: '100%', md: 'auto' } }}>
            <Typography fontSize={'14px'}>{t('editTrainingForm:comment:label')} : {comment}</Typography>
            {(typeof onEdit === 'function' && !restrictedMode) && <Button startIcon={<Edit />} onClick={onEdit} sx={{ float: 'right' }}>{t('button:edit')}</Button>}
        </Card>
    )
}

export default CommentSection